angular.module('bribac.components.testDetails', [
  'pascalprecht.translate',
  'bribac.services.showImageDetailModal',
  'bribac.values'
])

  .component('testDetails', {
    templateUrl: 'test-details-component.html',
    controller: 'TestDetailsCtrl',
    bindings: {
      test: '<',
      subject: '<',
      showProfileLink: '<'
    }
  })

  .controller('TestDetailsCtrl', function(
    $translate,
    $window,
    state,
    TEST_STATE,
    showImageDetailModal,
    api,
    KINDS
  ) {
    var $ctrl = this

    $ctrl.state = state
    $ctrl.TEST_STATE = TEST_STATE
    $ctrl.showLocationOnMap = false
    $ctrl.failReasons = []

    $ctrl.maxDecimals = function (number, decimals) {
      var factor = Math.pow(10, decimals);
      return Math.round(number * factor) / factor;
    };

    $ctrl.toggleLocationOnMap = function() {
      $ctrl.showLocationOnMap = !$ctrl.showLocationOnMap
    }

    $ctrl.getLocationMapLinkUrl = function() {
      var location = $ctrl.test.sample.location
      return 'https://www.google.com/maps?q=' + location.latitude + ',' + location.longitude + '&hl=' + $translate.use()
    }

    $ctrl.getLocationMapImageUrl = function() {
      var location = $ctrl.test.sample.location
      var geoFence = $ctrl.test && $ctrl.test.geoFence

      var url = 'https://maps.googleapis.com/maps/api/staticmap' +
        '?key=AIzaSyB7jDOsND9TEhHYtPgmDabxwt_4oN5t0Hw' +
        '&maptype=roadmap' +
        '&size=640x512' +
        '&language=' + $translate.use() +
        '&scale=' + ($window.devicePixelRatio > 1 ? 2 : 1) +
        '&markers=color:' + ($ctrl.test.state === TEST_STATE.PASSED ? 'green' : 'red') +
        '|label:S|' + location.latitude + ',' + location.longitude

      if (geoFence) {
        url += '&markers=color:blue|' + geoFence.latitude + ',' + geoFence.longitude

        var latDiff = Math.abs(location.latitude - geoFence.latitude)
        var longDiff = Math.abs(location.longitude - geoFence.longitude)
      }

      // If we only have one marker or the markers are too close to each other
      // we set a smaller zoom level than the automatic zoom level set so that
      // we can see more of the map and get extra context to help us understand
      // what we're looking at.
      var tooCloseLat = 0.0020
      var tooCloseLong = 0.007
      if (!geoFence || (latDiff <= tooCloseLat && longDiff <= tooCloseLong)) {
        url += '&zoom=15'
      }

      return url.replace('|', '%7C')
    }

    $ctrl.isLocationAvailable = function() {
      var location = $ctrl.test.sample.location
      return (location && location.latitude !== 0 && location.longitude !== 0)
    }

    $ctrl.showImageDetail = function() {
      showImageDetailModal($ctrl.test.sample.photo)
    }

    $ctrl.accept = function() {
      $ctrl.changeFaceRecognitionResult("PASSED")
    }

    $ctrl.decline = function() {
      $ctrl.changeFaceRecognitionResult("FAILED")
    }

    $ctrl.changeFaceRecognitionResult = function(newResult) {
      var data = {}
      if ($ctrl.test.sample.faceRecognition) {
        data = $ctrl.test.sample.faceRecognition
      } else {
        data.tolerance = 0
        data.sample = $ctrl.test.sample
      }
      data.result = newResult
      api[data.id ? 'put' : 'post'](KINDS.FACE_RECOGNITION, data).then(
        function success(response) {
            if ($ctrl.test && $ctrl.test.sample) {
              // Refresh the affected fields
              $ctrl.test.sample.faceRecognition = response.data
              $ctrl.test.sample.state = response.data.result
              if ($ctrl.test.state) {
                // Only in case of Non-optional sample
                $ctrl.test.state = response.data.result
              }
            }

            $ctrl.test = angular.copy($ctrl.test);
          }
      )
    }

    $ctrl.displayAlcosystemsFrsFailReason = function (alcosystemsFrsResult) {
      var failReson = alcosystemsFrsResult.failReason
      var split = failReson.split('_IMG_')
      var reason = {
        side: $translate.instant('components.testDetails.faceRecognition.' + split[0].toLowerCase(), null, "", "", ""),
        error: $translate.instant('alcosystemsFailReason.' + split[1], null, "", "", "")
      }
      $ctrl.failReasons.push($translate.instant('components.testDetails.faceRecognition.failReson', reason, "", "", ""));
    }

    $ctrl.filterFailReasons = function () {
      if (!$ctrl.test.sample || !$ctrl.test.sample.faceRecognition || !$ctrl.test.sample.faceRecognition.amarulaFrsResults) {
        return;
      }

      // Face recognition passed -> no need to check results
      if ($ctrl.test.sample.faceRecognition.result === 'PASSED') {
        return;
      }
      var failedComparisons = $ctrl.test.sample.faceRecognition.amarulaFrsResults.filter(function(it) {
        return it.failReason != null
      });

      if (failedComparisons.length === 0) {

        if ($ctrl.test.sample.faceRecognition.alcosystemsFrsResult) {
          $ctrl.displayAlcosystemsFrsFailReason($ctrl.test.sample.faceRecognition.alcosystemsFrsResult);
          return;
        }

        var livenessResults = $ctrl.test.sample.faceRecognition.livenessResults;

        livenessResults.forEach(function (result) {
          if (!result.isPassing) {
            var reason = {
              side: $translate.instant('components.testDetails.faceRecognition.' + (result.isLeftPhoto ? 'left' : 'right'), null, "", "", ""),
              error: $translate.instant('livenessError.' + (result.failReason ? result.failReason.name : 'LIVENESS_FAILED'), null, "", "", "")
            }
            $ctrl.failReasons.push($translate.instant('components.testDetails.faceRecognition.failReson', reason, "", "", ""));
          }
        });

        if ($ctrl.failReasons.length === 0) {
          if ($ctrl.test.sample.faceRecognition.amarulaFrsResults.length === 0) {
            // If liveness check PASSED and amarulaFrsResults is empty -> error on FRS service
            $ctrl.failReasons.push($translate.instant('frsFailReason.UNKNOWN', null, "", "", ""));
          } else {
            // If no comparison has failReason set + the result is failed + no liveness failed -> wrong color detected
            $ctrl.failReasons.push($translate.instant('frsFailReason.WRONG_COLOR', null, "", "", ""));
          }
          return;
        }

        return;
      }

      // Filter duplicities (comparison with multiple profile photos)
      var filtered = [];
      failedComparisons.forEach(function (comparison) {
        var x = filtered.filter(function (item) {
          return item.isLeftPhoto === comparison.isLeftPhoto && item.failReason.enumType === comparison.failReason.enumType;
        });
        if (x.length == 0) {
          filtered.push(comparison);
        }
      });

      // Add all results together to final
      filtered.forEach(function (it) {
        var reason =  {
          side: $translate.instant('components.testDetails.faceRecognition.' + (it.isLeftPhoto ? 'left' : 'right'), null, "", "", ""),
          error: $translate.instant('frsFailReason.' + it.failReason.name, null, "", "", "")
        }
        $ctrl.failReasons.push($translate.instant('components.testDetails.faceRecognition.failReson', reason, "", "", ""));
      })
    }

    $ctrl.$onInit = function () {
      $ctrl.filterFailReasons()
    }
  })
